import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const Pencil = (props: SvgProps) => (
  <Svg viewBox='0 0 51 51' {...props}>
    <Path
      d='M25.5 49C38.479 49 49 38.479 49 25.5S38.479 2 25.5 2 2 12.521 2 25.5 12.521 49 25.5 49Z'
      fill='currentColor'
      stroke='#fff'
      strokeWidth={3}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M29.662 17.695a2.577 2.577 0 0 1 3.643 3.643v0L21.009 33.634 16 35l1.366-5.01 12.296-12.295Z'
      stroke='#fff'
      strokeWidth={3}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
